<template>
    <div>
        <svg class="icon ais-SearchBox-icon">
            <use xlink:href="#geosearch-search" />
        </svg>

        <input
            ref="autocomplete"
            class="ais-SearchBox-input"
            type="text"
            placeholder="Search by suburb"
        />
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            autocomplete: null,
            listener: null
        };
    },

    mounted() {
        const googleCheck = setInterval(() => {
            if ('google' in window) {
                clearInterval(googleCheck);

                const input = this.$refs.autocomplete;
                this.autocomplete = new google.maps.places.Autocomplete(input);
                this.autocomplete.setOptions({ fields: ['geometry.location'] });
                this.autocomplete.setComponentRestrictions({
                    country: ['au']
                });
                this.autocomplete.setTypes(['(cities)']);

                this.listener = this.autocomplete.addListener('place_changed', () => {
                    const place = this.autocomplete.getPlace();
                    this.$emit('change', place.geometry.location);
                });
            }
        }, 250);
    },

    beforeDestroy() {
        google.maps.event.removeListener(this.listener);
    }
};
</script>
